import React from 'react';
import LandingNav from './components/LandingNav';
import HeroSection from './components/HeroSection';
import EmailCaptureSection from './components/EmailCaptureSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import MembershipSection from './components/MembershipSection';
import TestimonialsSection from './components/TestimonialsSection';
import ShowcaseSection from './components/ShowcaseSection';
import StatsStrip from './components/StatsStrip';
import ApplyToBeFeatureSection from './components/ApplyToBeFeatureSection';
import FinalCTASection from './components/FinalCTASection';
import LandingFooter from './components/LandingFooter';

const PublicLandingPage = () => {
  return (
    <div className="min-h-screen" style={{ fontFamily: 'Source Serif Pro, Georgia, serif' }}>
      <LandingNav />
      <HeroSection />
      <StatsStrip />
      <ApplyToBeFeatureSection />
      <EmailCaptureSection />
      <FeaturesSection />
      <HowItWorksSection />
      <MembershipSection />
      <TestimonialsSection />
      <ShowcaseSection />
      <FinalCTASection />
      <LandingFooter />
    </div>
  );
};

export default PublicLandingPage;
